import { render, staticRenderFns } from "./HomeWishlistBR.vue?vue&type=template&id=6a93753f&scoped=true"
import script from "./HomeWishlistBR.vue?vue&type=script&lang=js"
export * from "./HomeWishlistBR.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a93753f",
  null
  
)

export default component.exports